export const LIMIT_RECORDS_PER_REQUEST = 10;
export const START_PAGE = 0;
export const WAIT_SEARCH_TIME = 800;
export const CONSOLIDATED_ONE_ON_ONE_PREVIEW_TAKE = 2;
export const CONSOLIDATED_360_PREVIEW_TAKE = 3;
export const CONSOLIDATED_PEER_PREVIEW_TAKE = 3;
export const CONSOLIDATED_PULSE_PREVIEW_TAKE = 3;
